import * as Moff from '../constants/MoffAPI';
import { MoffAPI } from '../api/MoffApi';
import { Doctor, Hospital, Patient, Inquiry } from '../interfaces';

export const getAllPatients = () => {
  const moff = MoffAPI.instance;
  if (!moff) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.'
    };
  }
  return moff.getAllPatients(
    () => {
      return {
        type: Moff.LOADING,
        result: null
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (getAllPatientsStatus: any, result: any) => {
      switch (getAllPatientsStatus) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: result
          };
        case Moff.FETCH_PATIENTS_SUCCESS:
          return {
            type: Moff.FETCH_PATIENTS_SUCCESS,
            result: result
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.'
          };
      }
    }
  );
};

export const getPatientsBelongHospital = (patientId: string) => {
  const moff = MoffAPI.instance;
  if (!moff) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.'
    };
  }
  return moff.getPatientsBelongHospital(
    patientId,
    () => {
      return {
        type: Moff.LOADING,
        result: null
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (getAllPatientsStatus: any, result: any) => {
      switch (getAllPatientsStatus) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: result
          };
        case Moff.FETCH_PATIENTS_SUCCESS:
          return {
            type: Moff.FETCH_PATIENTS_SUCCESS,
            result: result
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.'
          };
      }
    }
  );
};

export const getPatientDetails = (patientId: string) => {
  const moff = MoffAPI.instance;
  if (!moff) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.'
    };
  }
  return moff.getPatientDetails(
    patientId,
    () => {
      return {
        type: Moff.LOADING,
        result: null
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (getAllPatientsStatus: any, result: any) => {
      switch (getAllPatientsStatus) {
        case Moff.LOADING:
        return {
          type: Moff.LOADING,
          result: null
        };
        case Moff.ERROR:
        return {
          type: Moff.ERROR,
          result: result
        };
        case Moff.SUCCESS:
        return {
          type: Moff.SUCCESS,
          result: result
        };
        case Moff.FETCH_PATIENT_DETAILS_SUCCESS:
        return {
          type: Moff.FETCH_PATIENT_DETAILS_SUCCESS,
          result: result
        };
        default:
        return {
          type: Moff.ERROR,
          result: '不明なエラーが発生しました.'
        };
      }
    }
  );
};

export const getHospitalDetails = (hospitalId: string) => {
  const moff = MoffAPI.instance;
  if (!moff) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.'
    };
  }
  return moff.getHospitalDetails(
    hospitalId,
    () => {
      return {
        type: Moff.LOADING,
        result: null
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (getAllHospitalStatus: any, result: any) => {
      switch (getAllHospitalStatus) {
        case Moff.LOADING:
        return {
          type: Moff.LOADING,
          result: null
        };
        case Moff.ERROR:
        return {
          type: Moff.ERROR,
          result: result
        };
        case Moff.SUCCESS:
        return {
          type: Moff.SUCCESS,
          result: result
        };
        case Moff.FETCH_HOSPITAL_DETAILS_SUCCESS:
        return {
          type: Moff.FETCH_HOSPITAL_DETAILS_SUCCESS,
          result: result
        };
        default:
        return {
          type: Moff.ERROR,
          result: '不明なエラーが発生しました.'
        };
      }
    }
  );
};

export const getDoctorDetails = (hospitalId: string) => {
  const moff = MoffAPI.instance;
  if (!moff) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.'
    };
  }
  return moff.getDoctorDetails(
    hospitalId,
    () => {
      return {
        type: Moff.LOADING,
        result: null
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (getDoctorDetailsStatus: any, result: any) => {
      switch (getDoctorDetailsStatus) {
        case Moff.LOADING:
        return {
          type: Moff.LOADING,
          result: null
        };
        case Moff.ERROR:
        return {
          type: Moff.ERROR,
          result: result
        };
        case Moff.SUCCESS:
        return {
          type: Moff.SUCCESS,
          result: result
        };
        case Moff.FETCH_DOCTOR_DETAILS_SUCCESS:
        return {
          type: Moff.FETCH_DOCTOR_DETAILS_SUCCESS,
          result: result
        };
        default:
        return {
          type: Moff.ERROR,
          result: '不明なエラーが発生しました.'
        };
      }
    }
  );
};

export const getDoctorDetailsBelongHospital = (hospitalId: string, doctorId: string) => {
  const moff = MoffAPI.instance;
  if (!moff) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.'
    };
  }
  return moff.getDoctorDetailsBelongHospital(
    hospitalId,
    doctorId,
    () => {
      return {
        type: Moff.LOADING,
        result: null
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (getDoctorDetailsStatus: any, result: any) => {
      switch (getDoctorDetailsStatus) {
        case Moff.LOADING:
        return {
          type: Moff.LOADING,
          result: null
        };
        case Moff.ERROR:
        return {
          type: Moff.ERROR,
          result: result
        };
        case Moff.SUCCESS:
        return {
          type: Moff.SUCCESS,
          result: result
        };
        case Moff.FETCH_DOCTOR_DETAILS_SUCCESS:
        return {
          type: Moff.FETCH_DOCTOR_DETAILS_SUCCESS,
          result: result
        };
        default:
        return {
          type: Moff.ERROR,
          result: '不明なエラーが発生しました.'
        };
      }
    }
  );
};

export const getDetails = (detailType: string, userId: string) => {
  if (detailType === 'patient') {
    return getPatientDetails(userId);
  } else if (detailType === 'hospital') {
    return getHospitalDetails(userId);
  } else if (detailType === 'doctor') {
    return getDoctorDetails(userId);
  }
};

export const getAllDoctors = () => {
  const moff = MoffAPI.instance;
  if (!moff) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.'
    };
  }
  return moff.getAllDoctors(
    () => {
      return {
        type: Moff.LOADING,
        result: null
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (getAllDoctorsStatus: any, result: any) => {
      switch (getAllDoctorsStatus) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: result
          };
        case Moff.FETCH_DOCTORS_SUCCESS:
          return {
            type: Moff.FETCH_DOCTORS_SUCCESS,
            result: result
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.'
          };
      }
    }
  );
};

export const getDoctorsBelongHospital = (hospitalId: string) => {
  const moff = MoffAPI.instance;
  if (!moff) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.'
    };
  }
  return moff.getDoctorsBelongHospital(
    hospitalId,
    () => {
      return {
        type: Moff.LOADING,
        result: null
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (getDoctorsBelongHospitalStatus: any, result: any) => {
      switch (getDoctorsBelongHospitalStatus) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: result
          };
        case Moff.FETCH_DOCTORS_IN_HOSPITAL_SUCCESS:
          return {
            type: Moff.FETCH_DOCTORS_IN_HOSPITAL_SUCCESS,
            result: result
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.'
          };
      }
    }
  );
};

export const getAllHospitals = () => {
  const moff = MoffAPI.instance;
  if (!moff) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.'
    };
  }
  return moff.getAllHospitals(
    () => {
      return {
        type: Moff.LOADING,
        result: null
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (getAllDoctorsStatus: any, result: any) => {
      switch (getAllDoctorsStatus) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: result
          };
        case Moff.FETCH_HOSPITALS_SUCCESS:
          return {
            type: Moff.FETCH_HOSPITALS_SUCCESS,
            result: result
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.'
          };
      }
    }
  );
};

export const getPatientDayTrainingLogs = (patientId: string) => {
  const moff = MoffAPI.instance;
  if (!moff) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.'
    };
  }
  return moff.getPatientDayTrainingLogs (
    patientId,
    () => {
      return {
        type: Moff.LOADING,
        result: null
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (getPatientDayTrainingLogsStatus: any, result: any) => {
      switch (getPatientDayTrainingLogsStatus) {
        case Moff.LOADING:
        return {
          type: Moff.LOADING,
          result: null
        };
        case Moff.ERROR:
        return {
          type: Moff.ERROR,
          result: result
        };
        case Moff.SUCCESS:
        return {
          type: Moff.SUCCESS,
          result: result
        };
        case Moff.FETCH_PATIENT_DAYTRAININGLOGS_SUCCESS:
        return {
          type: Moff.FETCH_PATIENT_DAYTRAININGLOGS_SUCCESS,
          result: result
        };
        default:
        return {
          type: Moff.ERROR,
          result: '不明なエラーが発生しました.'
        };
      }
    }
  );
};

export const getPatientsDayTrainingLogs = (patientIds: any) => {
  const moff = MoffAPI.instance;
  if (!moff) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.'
    };
  }
  return moff.getPatientsDayTrainingLogs (
    patientIds,
    () => {
      return {
        type: Moff.LOADING,
        result: null
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (getPatientsDayTrainingLogsStatus: any, result: any) => {
      switch (getPatientsDayTrainingLogsStatus) {
        case Moff.LOADING:
        return {
          type: Moff.LOADING,
          result: null
        };
        case Moff.ERROR:
        return {
          type: Moff.ERROR,
          result: result
        };
        case Moff.SUCCESS:
        return {
          type: Moff.SUCCESS,
          result: result
        };
        case Moff.FETCH_PATIENTS_DAYTRAININGLOGS_SUCCESS:
        return {
          type: Moff.FETCH_PATIENTS_DAYTRAININGLOGS_SUCCESS,
          result: result
        };
        default:
        return {
          type: Moff.ERROR,
          result: '不明なエラーが発生しました.'
        };
      }
    }
  );
};

export const postAddHospital = (hospitalName: string): any => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.postAddHospital(
    {
      name: hospitalName
    },
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.ADD_HOSPITAL_SUCCESS:
          return {
            type: Moff.ADD_HOSPITAL_SUCCESS,
            result: result,
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

export const postAddPatient = (params: Patient): any => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.postAddPatient(
    params,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.ADD_PATIENT_SUCCESS:
          return {
            type: Moff.ADD_PATIENT_SUCCESS,
            result: result,
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

export const postAddDoctor = (params: Doctor): any => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.postAddDoctor(
    params,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.ADD_DOCTOR_SUCCESS:
          return {
            type: Moff.ADD_DOCTOR_SUCCESS,
            result: result,
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

export const putUpdateHospital = (params: Hospital): any => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.putUpdateHospital(
    params,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.UPDATE_HOSPITAL_SUCCESS:
          return {
            type: Moff.UPDATE_HOSPITAL_SUCCESS,
            result: result,
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

export const putUpdateDoctor = (params: Doctor): any => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.putUpdateDoctor(
    params,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.UPDATE_DOCTOR_SUCCESS:
          return {
            type: Moff.UPDATE_DOCTOR_SUCCESS,
            result: result,
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

export const putUpdatePatient = (params: Patient): any => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.putUpdatePatient(
    params,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.UPDATE_PATIENT_SUCCESS:
          return {
            type: Moff.UPDATE_PATIENT_SUCCESS,
            result: result,
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

export const putUpdateInquiry = (params: Inquiry): any => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.putUpdateInquiry(
    params,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result,
          };
        case Moff.UPDATE_INQUIRY_SUCCESS:
          return {
            type: Moff.UPDATE_INQUIRY_SUCCESS,
            result: result,
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};

export const getAllInquiries = () => {
  const moff = MoffAPI.instance;
  if (!moff) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.'
    };
  }
  return moff.getAllInquiries(
    () => {
      return {
        type: Moff.LOADING,
        result: null
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (getAllInquiriesStatus: any, result: any) => {
      switch (getAllInquiriesStatus) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: result
          };
        case Moff.SUCCESS:
          return {
            type: Moff.SUCCESS,
            result: result
          };
        case Moff.FETCH_INQUIRIES_SUCCESS:
          return {
            type: Moff.FETCH_INQUIRIES_SUCCESS,
            result: result
          };
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.'
          };
      }
    }
  );
};

export const getInquiryDetails = (inquiryId: string) => {
  const moff = MoffAPI.instance;
  if (!moff) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.'
    };
  }
  return moff.getInquiryDetails(
    inquiryId,
    () => {
      return {
        type: Moff.LOADING,
        result: null
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (getInquiryDetailsStatus: any, result: any) => {
      switch (getInquiryDetailsStatus) {
        case Moff.LOADING:
        return {
          type: Moff.LOADING,
          result: null
        };
        case Moff.ERROR:
        return {
          type: Moff.ERROR,
          result: result
        };
        case Moff.SUCCESS:
        return {
          type: Moff.SUCCESS,
          result: result
        };
        case Moff.FETCH_INQUIRY_SUCCESS:
        return {
          type: Moff.FETCH_INQUIRY_SUCCESS,
          result: result
        };
        default:
        return {
          type: Moff.ERROR,
          result: '不明なエラーが発生しました.'
        };
      }
    }
  );
};

export const getUserName = () => {
  const moff = MoffAPI.instance;
  if (!moff) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.'
    };
  }
  return moff.requestGetUserName(
    () => {
      return {
        type: Moff.LOADING,
        result: null
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (getUserNameStatus: any, result: any) => {
      switch (getUserNameStatus) {
        case Moff.LOADING:
        return {
          type: Moff.LOADING,
          result: null
        };
        case Moff.ERROR:
        return {
          type: Moff.ERROR,
          result: result
        };
        case Moff.FETCH_USER_NAME_SUCCESS:
        return {
          type: Moff.FETCH_USER_NAME_SUCCESS,
          result: result
        };
        default:
        return {
          type: Moff.ERROR,
          result: '不明なエラーが発生しました.'
        };
      }
    }
  );
};

export const getUserId = () => {
  const moff = MoffAPI.instance;
  if (!moff) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.'
    };
  }
  return moff.requestGetUserId(
    () => {
      return {
        type: Moff.LOADING,
        result: null
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (getUserIdStatus: any, result: any) => {
      switch (getUserIdStatus) {
        case Moff.LOADING:
        return {
          type: Moff.LOADING,
          result: null
        };
        case Moff.ERROR:
        return {
          type: Moff.ERROR,
          result: result
        };
        case Moff.FETCH_USER_ID_SUCCESS:
        return {
          type: Moff.FETCH_USER_ID_SUCCESS,
          result: result
        };
        default:
        return {
          type: Moff.ERROR,
          result: '不明なエラーが発生しました.'
        };
      }
    }
  );
};


// WEBPACK FOOTER //
// ./src/actions/MoffApi.tsx